// extracted by mini-css-extract-plugin
export default {"quickServices":"QuickServices_quickServices__7U0-a","grid":"QuickServices_grid__MK4-u"};